import Cookies from 'js-cookie'

const TokenKey = 'Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setToken2(token,expires) {
  return Cookies.set(TokenKey, token,{ expires:expires*1.00/(24*60*60), path: '' })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
